import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { getUser } from 'src/utils/Common';
import { connect } from 'react-redux';
import {
  Typography,
  Grid,
} from '@material-ui/core';
import { text } from '../../modules/languages/index';
import KesifSmsGonder from '../../components/DiscoverySms';

const useStyles = makeStyles((theme) => ({
  root: {},
  summaryButton: {
    backgroundColor: theme.palette.common.white
  },
  barChartIcon: {
    marginRight: theme.spacing(1)
  },
  image: {
    width: '100%',
    maxHeight: 400
  }
}));

function FormHeader({ className, headerTitle, FisNo, dispatch, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const [KesifSms, setKesifSms] = useState(false);

  const handleKesifSmsClose = () => {
    setKesifSms(false);
  }
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid
        alignItems="center"
        container
        justifyContent="space-between"
        spacing={3}
      >
        <Grid
          item
          md={6}
          xs={9}
        >
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            {text('iyi_gunler')}
            ,
            {' '}
            {SessionUser.FirstName}
            {' '}
            {SessionUser.LastName}
          </Typography>
          <Typography
            gutterBottom
            variant="subtitle1"
          >
            {`${headerTitle} ile ilgili olarak ekli formu doldurabilirsiniz!...`}
          </Typography>
        </Grid>
        <Grid
          item
          // onClick={KesifSmsAt}
          md={6}
          xs={2}>
          {/* <FaSms color='#FF9800' size='3em' /> */}
        </Grid>
        <Grid
          item
          md={6}
          xs={1}>

        </Grid>
      </Grid>
      <KesifSmsGonder
        onClose={handleKesifSmsClose}
        FisNo={FisNo}
        open={KesifSms}
        headerTitle={headerTitle}
      />
    </div>
  );
}

FormHeader.propTypes = {
  className: PropTypes.string,
  headerTitle: PropTypes.string
};

export default connect(
  () => ({}),
  null
)(FormHeader);
